import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

export const ProModal = ({ isOpen, closeModal }) => {
  const [bePremium, setToBePremium] = useState(false);

  return (
    <Dialog open={isOpen} onClose={closeModal} maxWidth="md">
      <DialogTitle>Faktual Pro</DialogTitle>
      {!bePremium ? (
        <>
          <DialogContent>
            <DialogContentText>
              Faktual Pro bietet weitere Features wie zum Beispiel das
              hinzufügen eigener Quellen und eine überarbeitete
              Benutzeroberfläche. Möchten Sie faktual Pro testen und unser Team
              durch Ihr wertvolles Feedback unterstützen?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="secondary" onClick={closeModal}>
              Nein
            </Button>
            <Button color="primary" onClick={() => setToBePremium(true)}>
              Ja
            </Button>
          </DialogActions>
        </>
      ) : (
        <DialogContent>
          <DialogContentText>
            Vielen Dank. Sie erhalten in kürze eine Mail mit Zugang zur Beta
            Version.
          </DialogContentText>
          <DialogActions>
            <Button color="primary" onClick={closeModal}>
              OK
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProModal);
